
export class Cumplimiento {
    constructor(Banco, Afiliaciones, Meta) {
        this.Banco = Banco;
        this.Afiliaciones = Afiliaciones;
        this.Meta=Meta;
    }
}